import { render, staticRenderFns } from "./VeJwGzzjList.vue?vue&type=template&id=93b7c008&scoped=true"
import script from "./VeJwGzzjList.vue?vue&type=script&lang=js"
export * from "./VeJwGzzjList.vue?vue&type=script&lang=js"
import style0 from "./VeJwGzzjList.vue?vue&type=style&index=0&id=93b7c008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b7c008",
  null
  
)

export default component.exports